<template>
  <div v-if="items.length" class="rpt-section">
    <div class="rpt-section-header">
      <h2 class="rpt-section-title">
        By Player ({{ items.length }} of {{ totalCount }})
      </h2>
      <button
        class="rpt-section-export-btn"
        @click="$emit('exportSection')"
        title="Export By Player data"
      >
        <ExportIcon class="rpt-section-export-icon" />
      </button>
    </div>
    <div class="rpt-table-wrap">
      <table class="rpt-table">
        <thead>
          <tr>
            <th class="rpt-th" style="text-align: left">Player</th>
            <th class="rpt-th rpt-th-num">Total Plays</th>
            <th class="rpt-th rpt-th-num">Unique Media</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="p in items"
            :key="p.player_uuid"
            class="rpt-row"
          >
            <td class="rpt-td rpt-td-player">
              <a
                v-if="playerInfoByUuid[p.player_uuid]?.id"
                :href="playerHref(playerInfoByUuid[p.player_uuid]!.id)"
                target="_blank"
                rel="noopener noreferrer"
                class="rpt-player-link"
              >
                {{ playerInfoByUuid[p.player_uuid]?.name || p.player_uuid }}
              </a>
              <span v-else class="rpt-td-uuid">{{ p.player_uuid }}</span>
            </td>
            <td class="rpt-td rpt-td-num">
              {{ p.total_plays.toLocaleString() }}
            </td>
            <td class="rpt-td rpt-td-num">{{ p.unique_media_count }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="hasMore || isLoadingMore" class="rpt-load-more-row">
        <button
          class="rpt-btn rpt-btn-load-more"
          :disabled="isLoadingMore"
          @click="$emit('loadMore')"
        >
          <span v-if="isLoadingMore" class="rpt-spinner" />
          <span v-else>Load more</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import type { ProofOfPlayByPlayer } from '@/helpers/api/metrics';
import ExportIcon from '@/components/icons/ExportIcon.vue';

defineProps<{
  items: ProofOfPlayByPlayer[]
  totalCount: number
  isLoadingMore: boolean
  hasMore: boolean
  playerInfoByUuid: Record<string, { name: string; id: number } | undefined>
}>()

defineEmits<{
  (e: 'loadMore'): void
  (e: 'exportSection'): void
}>()

const router = useRouter();

function playerHref(id: number): string {
  return router.resolve({ name: 'player-editor', params: { id: String(id) } }).href;
}
</script>

<style scoped>
@import '@/views/ReportsView/styles/reports-shared.css';

.rpt-td-uuid {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8rem;
  color: #4b5563;
}

.rpt-td-player {
  max-width: 18rem;
  word-break: break-word;
}

.rpt-player-link {
  color: #25294A;
  font-weight: 600;
  text-decoration: none;
}

.rpt-player-link:hover {
  text-decoration: underline;
}
</style>
